import { PricingSection, PricingSectionPriceDetail } from "./PricingSection";

function EventiveTicketing() {
  return (
    <PricingSection
      title="Eventive Ticketing"
      description="Sell tickets, passes, and items &ndash; online, at-the-door and anywhere in between. All below fees can be passed to customers and organizers can use Eventive for free."
      subhead="No ticketing fees on donations, concessions, or on-site merch sales"
      includedItems={[
        <>
          Credit card processing included &ndash; discounts available for
          non-profits and/or volume over $100k/month
        </>,
        "No ticketing fees on donations, concessions, or on-site merch sales",
        "Desktop, mobile, and iPad Box Office",
        "Seamless integration with Eventive Scanner, Eventive Terminal, ticket and pass printing, and full physical point-of-sale",
      ]}
      priceDetail={
        <PricingSectionPriceDetail
          title="Paid credit card sales"
          description={
            <>
              Per item. No fees on free tickets or free passes. No fees on cash
              or check sales. No ticketing fees on donations.{" "}
              <span className="font-bold">
                All-inclusive &ndash; includes all credit card processing fees.
              </span>
            </>
          }
          buttonLabel="Start selling"
          buttonHref="/start"
          prices={[
            { price: "5% + 99c", priceNote: "USD" },
            { price: "3.5% + 75p", priceNote: "GBP" },
            { price: "5% + 99c", priceNote: "CAD" },
            { price: "3.5% + 90c", priceNote: "EUR" },
            { price: "3.5% + 10Kr.", priceNote: "NOK" },
            { price: "3.5% + 9kr", priceNote: "SEK" },
            { price: "3.85% + 99c", priceNote: "AUD" },
            { price: "5% + 99c", priceNote: "NZD" },
            { price: "3.5% + 6.75kr", priceNote: "DKK" },
          ]}
          footer={
            <div className="mt-2 text-gray-500">
              Don&apos;t see your currency?{" "}
              <button
                className="font-medium text-gray-900 focus:outline-none"
                onClick={() => {
                  Intercom(
                    "showNewMessage",
                    "I'm interested in learning more about country-specific pricing for Eventive! My name, organization, and country are: "
                  );
                }}
              >
                Contact us.
              </button>
            </div>
          }
        />
      }
      additionalDescription={
        <div className="text-sm leading-5">
          Registered non-profit? Free donations and statement credit available –{" "}
          <button
            className="font-medium text-gray-900 focus:outline-none"
            onClick={() => {
              Intercom(
                "showNewMessage",
                "I'm interested in learning more about non-profit discounts for Eventive! My name and organization are: "
              );
            }}
          >
            get in touch
          </button>
          .
        </div>
      }
    />
  );
}

export default EventiveTicketing;
